import { render, staticRenderFns } from "./projectMaintenance.vue?vue&type=template&id=a8545d28&scoped=true"
import script from "./projectMaintenance.vue?vue&type=script&lang=js"
export * from "./projectMaintenance.vue?vue&type=script&lang=js"
import style0 from "./projectMaintenance.vue?vue&type=style&index=0&id=a8545d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8545d28",
  null
  
)

export default component.exports